import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios, { AxiosResponse } from 'axios';

export interface IConfigApi {
  getConfig(): Promise<AxiosResponse<any>>;
  getInfos(): Promise<APIResponse<any>>;
  getProfile(): Promise<AxiosResponse<any>>;
  getAuthInfo(): Promise<APIResponse<any>>;
}

export class ConfigApi implements IConfigApi {
  async getConfig(): Promise<AxiosResponse<any>> {
    return axios.get('/data/config.json');
  }

  async getInfos(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('/api/infos'));
  }

  async getProfile(): Promise<AxiosResponse<any>> {
    return axios.get('management/info');
  }

  async getAuthInfo(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('/api/auth-info'));
  }
}
